import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#05060a] text-white">
        <div className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.22em] text-white/45">
          <span className="h-2 w-2 animate-pulse rounded-full bg-[#e01e37]" />
          Sitzung wird geprüft
        </div>
      </div>
    );
  }

  return user ? children : <Navigate to="/login" replace state={{ from: location.pathname }} />;
}
